module.exports = __webpack_public_path__ + "static/mv-logo-116c098dc1c58cef297e91118db5badc.png";